import React from "react"
import {
  autresActualites,
  actualiteContainerFirst,
  actualiteContainer,
  autresActualitesResponsiveOnly,
  linkActu,
  actualiteCarouselDotsWrapper,
} from "../actualites.module.scss"
import ActuItem from "../ActuItem/actu-item"
import PropTypes from "prop-types"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import MultiCarousel from "react-multi-carousel"
import {
  carouselArrowRight,
  carouselArrowLeft,
} from "../../../Transformers/CarouselTransformer/carousel-transformer.module.scss"
import { CustomArrows } from "../../Carousel/custom-arrow-styled"

const RenderActualites = ({ actualiteData }) => {
  const actus = actualiteData
  const firstActu = actus[0].node
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 900, min: 0 },
      items: 1,
    },
  }
  return (
    <>
      <TransitionFade
        className={linkActu}
        link={firstActu.path.alias}
        arialabel="Lien vers l'actualité"
      >
        <ActuItem myClassName={actualiteContainerFirst} actu={firstActu} />
      </TransitionFade>
      <MultiCarousel
        className={autresActualites}
        transitionDuration={500}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        responsive={responsive}
        infinite={true}
        arrows={true}
        autoPlay={false}
        shouldResetAutoplay={false}
        renderButtonGroupOutside={true}
      >
        {actus.slice(1).map(({ node }) => {
          return (
            <TransitionFade
              key={node.drupal_id}
              className={linkActu}
              link={node.path.alias}
              arialabel="Lien vers l'actualité"
            >
              <ActuItem myClassName={actualiteContainer} actu={node} />
            </TransitionFade>
          )
        })}
      </MultiCarousel>
      <MultiCarousel
        className={(autresActualites, autresActualitesResponsiveOnly)}
        transitionDuration={500}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        responsive={responsive}
        infinite={true}
        arrows={true}
        autoPlay={false}
        showDots={true}
        dotListClass={actualiteCarouselDotsWrapper}
        shouldResetAutoplay={false}
        renderButtonGroupOutside={true}
      >
        {actus.map(({ node }) => {
          return (
            <TransitionFade
              key={node.drupal_id}
              className={linkActu}
              link={node.path.alias}
              arialabel="Lien vers l'actualité"
            >
              <ActuItem myClassName={actualiteContainer} actu={node} />
            </TransitionFade>
          )
        })}
      </MultiCarousel>
    </>
  )
}

const CustomRightArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrows className={carouselArrowRight} onClick={() => onClick()} />
  )
}
const CustomLeftArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrows className={carouselArrowLeft} onClick={() => onClick()} />
  )
}

RenderActualites.propTypes = {
  actualiteData: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

CustomRightArrow.propTypes = {
  onClick: PropTypes.func,
}

CustomLeftArrow.propTypes = {
  onClick: PropTypes.func,
}

export default RenderActualites
